import MergeLinkDialog from "./MergeLinkDialog";

export default MergeLinkDialog;
